export function noCommaValue(val: string): string {
  if (val !== undefined && val !== null) {
    // here we just remove the commas from value
    return val.toString().replace(/,/g, '');
  } else {
    return '';
  }
}
